(function () {
  'use strict';

  angular.module('ringbaPortal').component('tcpaShieldBilling', {
    bindings: {
    },
    controller: TcpaShieldBillingController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/tcpa-shield/tcpa-shield-billing.view.html'
  });

  function TcpaShieldBillingController(
    $uibModal,
    $scope,
    billingService,
    accountsService,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;

    vm.changePlan = changePlan;
    vm.cancelModal = cancelModal;
    vm.selectPlan = selectPlan;
    vm.amountToCharge = amountToCharge;
    vm.currentAccountId = accountsService.currentAccountId;
    vm.updatePlanType = updatePlanType;

    function onInit() {
      loadBillingPlans();
    }

    function cancelModal() {
      vm.planid = null;
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function selectPlan(plan) {
      vm.planid = plan.id;

    }

    function amountToCharge() {
      if (vm.planid) {
        const tempPlan = _.findLast(vm.plans, function (p) {
          return p.id === vm.planid;
        });

        return Math.max(0, tempPlan.monthlyCharge - vm.plan.monthlyCharge);
      }

      return 0;
    }

    function loadBillingPlans() {
      return billingService.getTCPABillingInfo(vm.currentAccountId)
        .then(function (plan) {
          vm.plan = plan;
        })
        .catch(utils.errorHandler);
    }

    function changePlan() {
      billingService.getTCPABillingPlans(vm.currentAccountId).then(function (plans) {
        vm.plans = plans.data.plans;
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/components/tcpa-shield/tcpa-shield-billing-change-plan.modal.html',
          scope: $scope,
          controllerAs: 'vm',
          size: 'xl'

        });
      });
    }

    function updatePlanType() {

    }


  }
})();
